import Vue from 'vue'
import Router from 'vue-router'
import menuModule from '@/store/modules/menu';
import _menu from '@/_menu';

const defaultcontainer = () => import('@/containers/DefaultContainer');
const login = () => import('@/views/pages/login');
const logout = () => import('@/views/pages/logout');
const ticketdetails = () => import('@/views/pages/ticketdetails');


Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
      path: '/',
      redirect: 'welcome',
      name: 'defaultcontainer',
      component: defaultcontainer,
      children: [
        ...f_getSideBarMenu(),
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    }, {
      path: '/logout',
      name: 'logout',
      component: logout,
    },
    // {
    //   path: '/ticketdetails',
    //   name: 'ticketdetails',
    //   component: ticketdetails,
    // },
  ]
})

function f_getSideBarMenu() {
  let side_bar_menu = [];
  for (let i in _menu.website_data.page_list) {
    if (_menu.website_data.page_list[i].route_path) {
      const new_item = {
        'path': _menu.website_data.page_list[i].route_path,
        'component': () => import('../views/pages/' + _menu.website_data.page_list[i].route_name),
        'name': _menu.website_data.page_list[i].route_name
      };
      side_bar_menu.push(new_item);
    }
    if (_menu.website_data.page_list[i].sub_menu && _menu.website_data.page_list[i].sub_menu.length > 0) {
      for (let sub_i in _menu.website_data.page_list[i].sub_menu) {
        if (_menu.website_data.page_list[i].sub_menu[sub_i].route_path) {
          const new_item = {
            'path': _menu.website_data.page_list[i].sub_menu[sub_i].route_path,
            'component': () => import('../views/pages/' + _menu.website_data.page_list[i].sub_menu[sub_i].route_name),
            'name': _menu.website_data.page_list[i].sub_menu[sub_i].route_name
          };
          side_bar_menu.push(new_item);
        }
      }

    }
  }
  // console.log(side_bar_menu);
  return side_bar_menu;
}

